export default __webpack_public_path__ + "static/O0005-78d4d158ec59b824641ef25f27501f39.png";